var _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAnonymousGrave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3722_24232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3722_24232)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 24,
    r: 6,
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 14L67.7321 17H64.2679L66 14Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 34L64.2679 31L67.7321 31L66 34Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 24L73 25.7321L73 22.2679L76 24Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 24L59 22.2679L59 25.7321L56 24Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0711 31.0714L69.7251 30.1749L72.1746 27.7254L73.0711 31.0714Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9289 16.9286L62.2749 17.8251L59.8254 20.2746L58.9289 16.9286Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9286 31.0711L59.8251 27.7251L62.2746 30.1746L58.9286 31.0711Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0714 16.9289L72.1749 20.2749L69.7254 17.8254L73.0714 16.9289Z",
    fill: "#68A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.92883 57.0238C-9.92883 57.0238 43.9637 31.0317 102.941 54.2777C102.941 54.2777 102.049 115.959 31.7939 105.682C-2.76733 100.627 -9.92883 57.0238 -9.92883 57.0238Z",
    fill: "#2974B2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 69C40.4556 66.4892 43.2979 65.2984 45.388 66.0516C46.415 66.4247 47.1238 66.769 48.2231 66.5897C49.8287 66.2668 51.0437 65.0258 52.5624 64.4376C53.3089 64.1064 54.1251 63.9596 54.9413 64.0095C55.7574 64.0595 56.5492 64.3048 57.249 64.7245C58.5508 65.4419 59.6862 66.7331 61.111 66.9842C63.0854 67.3357 64.9441 66.5251 66.0289 69H40Z",
    fill: "#093E62"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAnonymousGrave);
export default __webpack_public_path__ + "static/media/imgAnonymousGrave.7b192a3ed4a1cb3457aa411e3bfa9b98.svg";
export { ForwardRef as ReactComponent };